import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import clsx from 'clsx';

import { PauseIcon, PlayIcon } from '@common/icons';

import { useImageService } from '../services/useImageService';
import { ProgressiveImage } from './ProgressiveImage';

export interface ImageProps extends React.HTMLProps<HTMLDivElement> {
  image: ImageObjectProps;
  is_fit_contain?: boolean;
  onLoad?: () => void;
}

export interface ImageObjectProps {
  url: string | null;
  origin_url: string;
  static_url: string | null;
}

export const Image: React.FC<React.PropsWithChildren<ImageProps>> = ({ image, is_fit_contain = false, onLoad }) => {
  const { image_source, low_quality_image, is_gif, is_static, isStaticTriggerAvailable, handleToggle } =
    useImageService({ image });

  return (
    <div css={wrapperCss} className={clsx([is_fit_contain && 'is-fit-contain-image'])}>
      <ProgressiveImage
        low_quality_image={low_quality_image}
        high_quality_image={image_source}
        is_static={is_static}
        use_gif={is_gif}
        alt='상품 이미지'
        onLoad={onLoad}
        disable_skeleton={is_fit_contain}
      />
      {isStaticTriggerAvailable() && (
        <ButtonArea onClick={handleToggle}>
          <ToggleToStaticButton type='button'>
            {is_static ? <PlayIcon /> : <PauseIcon />}
            <span>&nbsp;GIF</span>
          </ToggleToStaticButton>
        </ButtonArea>
      )}
    </div>
  );
};

const wrapperCss = css`
  position: relative;
  width: 100%;
  height: 100%;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.is-fit-contain-image img {
    object-fit: contain;
  }
`;

const ButtonArea = styled.div`
  padding: 7px 0;
  position: absolute;
  bottom: 12px;
  right: 16px;
`;

const ToggleToStaticButton = styled.button`
  height: 24px;
  padding: 0 8px;
  background: rgba(0, 0, 0, 0.7);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.6);
  vertical-align: top;
  cursor: pointer;

  & > svg {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-top: 7px;
    vertical-align: top;
  }
  & > span {
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
    line-height: 24px;
    font-family: Avenir;
    font-weight: 800;
  }
`;
